import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// Parameters that describe the page itself, not the panel opened on top of it:
// closing a slide-over must not send the user back to the current month, nor
// close the mission being read underneath.
//
// `mission` is not a memory of what was open — the mission detail is *derived*
// from it, live. Wiping it on the way out of a slide-over closed the detail on
// the spot, which is what happened when confirming a planning.
const PRESERVED_PARAMETERS = ['y', 'm', 'mission'];

export const preservedSearch = (search) => {
  const current = new URLSearchParams(search);
  const preserved = new URLSearchParams();
  PRESERVED_PARAMETERS.forEach((key) => {
    if (current.has(key)) preserved.set(key, current.get(key));
  });
  return preserved.toString();
};

// Clearing the query string has to go through the router. Doing it with
// window.history.replaceState changes the address bar but leaves useLocation()
// stale, so a later navigate() to that same URL is treated as a no-op — which
// is how closing a company slide-over used to make it impossible to reopen.
const useUrlParameters = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const removeAllParameters = useCallback(() => {
    navigate(
      { pathname: location.pathname, search: preservedSearch(location.search) },
      { replace: true },
    );
  }, [navigate, location.pathname, location.search]);

  return { removeAllParameters };
};

export default useUrlParameters;
